export const AppVersion="1.0.1"

export const MENU_ITEMS = [
    {
      title: "Dashboards",
      icon: "bi bi-house-door-fill",
      tooltip: "Dashboards",
      id: "pills-dashboards",
      links: [
        { name: "Home", path: "/", icon: "lni lni-home" },
        { name: "Order List", path: "/order/list", icon: "bi bi-bar-chart" },
        { name: "Order Create", path: "/order/create-order", icon: "bi bi-bar-chart" },
        { name: "Add Measurement", path: "/order/add-measurement", icon: "bi bi-box" },
        { name: "Measurements", path: "/order/measurements", icon: "bi bi-bar-chart" },
        { name: "Quotations", path: "/order/quotations", icon: "bi bi-file-earmark-text" },
      ],
    },
    {
      title: "Order System",
      icon: "lni lni-cart",
      tooltip: "Order",
      id: "pills-orders",
      links: [
        { name: "Order List", path: "/order/list", icon: "bi bi-bar-chart" },
        { name: "Order Create", path: "/order/create-order", icon: "bi bi-bar-chart" },
      ],
    },
    {
      title: "Measurement System",
      icon: "bi bi-rulers",
      tooltip: "Measurement",
      id: "pills-measurements",
      links: [
        { name: "Add Measurement", path: "/order/add-measurement", icon: "bi bi-box" },
        { name: "Measurements", path: "/order/measurements", icon: "bi bi-bar-chart" },
        { name: "Quotations", path: "/order/quotations", icon: "bi bi-file-earmark-text" },
      ],
    },
    {
      title: "Analytics",
      icon: "bi bi-graph-up",
      tooltip: "Analytics",
      id: "pills-analytics",
      links: [
        { name: "Revenue Stats", path: "/analytics/revenue-stats", icon: "bi bi-currency-dollar" },
        { name: "Product Distribution", path: "/analytics/product-distribution", icon: "bi bi-pie-chart" },
      ],
    },
    {
      title: "Invoices",
      icon: "bi bi-receipt",
      tooltip: "Dealer Invoices",
      id: "pills-invoices",
      links: [
        { name: "Dealer Invoices", path: "/invoices/dealer-invoices", icon: "bi bi-file-earmark-text" },
      ],
    },
  ];